import { Link } from "react-router-dom";

export const Logo = ({ light = false, className = "" }) => (
  <Link to="/" data-testid="site-logo" aria-label="BWI — Built With Intention, home" className={`group inline-flex flex-col leading-none ${className}`}>
    <span className={`font-serif text-[1.9rem] font-medium tracking-[0.32em] pl-[0.32em] ${light ? "text-ivory" : "text-wine"}`}>
      B<span className="italic font-light">W</span>I
    </span>
    <span className={`mt-1 flex items-center gap-2 font-sans text-[0.58rem] uppercase tracking-[0.34em] ${light ? "text-ivory/80" : "text-charcoal/70"}`}>
      <span className={`h-px w-4 ${light ? "bg-ivory/50" : "bg-champagne"}`} />
      Built With Intention
    </span>
  </Link>
);
